import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-10 w-full rounded-md border border-line-1 bg-ink-2 px-3.5 py-2 text-base text-stark transition-all duration-200 ease-precision file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-stark placeholder:text-stark-3 placeholder:font-mono placeholder:text-sm focus-visible:outline-none focus-visible:border-white focus-visible:ring-0 hover:border-line-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
